<app-single-detail svgIcon="feather:hash" label="Client #" [value]="inboundDetailsModel?.clientId"></app-single-detail>
<app-single-detail svgIcon="feather:user" label="Client" [value]="inboundDetailsModel?.clientName"></app-single-detail>
<app-single-detail
  svgIcon="hero_outline:office-building"
  label="Site"
  [value]="inboundDetailsModel?.siteName"></app-single-detail>
<app-single-detail
  svgIcon="feather:crosshair"
  label="Location"
  [value]="inboundDetailsModel?.siteLocationCode"></app-single-detail>
